
import { defineComponent, ref, reactive, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import InvoiceBanner from '@/components/Invoice/Banner/index.vue'
import InvoiceRule from '@/components/Invoice/Rule/index.vue'
import InvoiceButton from '@/components/Invoice/Button/index.vue'
import InvoicePopup from '@/components/Invoice/Popup/index.vue'
import {
  useAxiosInvoiceInfo,
  setHeaders,
  setAppBaseUrl
} from '../axios/index'
import { useStore } from 'vuex'

const popupDataDefault: {
  title: string | null
  message: string | null
  type: string | null
  isLogin: Boolean
  isWallet: Boolean
  isClose: Boolean
  isColorClose: Boolean
} = {
  title: null,
  message: null,
  type: null,
  isLogin: false,
  isWallet: false,
  isClose: false,
  isColorClose: false
}

export default defineComponent({
  name: 'Invoice',
  components: { InvoiceBanner, InvoiceRule, InvoiceButton, InvoicePopup },
  props: {},
  setup(props, { emit }) {
    const router = useRouter()
    const route = useRoute()
    let isPopupOpen = ref(false)
    let popupData = reactive(popupDataDefault)
    const { get, post, result } = useAxiosInvoiceInfo()
    const store = useStore()
    setAppBaseUrl()
    function handler() {
      setHeaders('Authorization', `Bearer ${route.query.key}`)
      post(result.event_id).then(() => {
        popupData = reactive(popupDataDefault)
        popupData.title = '登記成功'
        popupData.type = 'success'
        openPopup()
        timer()
      })
    }
    function handleLogin() {
      closePopup()
      window.MobileApp.call('', 'GoToLogin')
    }

    function handleWallet() {
      closePopup()
      window.MobileApp.call('', 'GoToWallet')
    }

    function openPopup() {
      isPopupOpen.value = true
    }
    function closePopup() {
      isPopupOpen.value = false
    }
    function timer() {
      setTimeout(() => {
        closePopup()
      }, 3000)
    }
    get()

    watch(
      () => store.state.invoiceStatus,
      (
        newValue: { code: string; message: string },
        oldvalue: { code: string; message: string }
      ) => {
        popupData = reactive(popupDataDefault)
        console.log('newValue :>> ', newValue)
        switch (newValue.code) {
          case '0000':
            break
          case '401':
            popupData.title = '請先登入會員'
            popupData.message = newValue.message
            popupData.isLogin = true
            popupData.isClose = true
            openPopup()
            break
          case '4001':
            popupData.title = '請重新登入會員'
            popupData.message = newValue.message
            popupData.isLogin = true
            popupData.isClose = true
            openPopup()
            break
          case '1000':
            popupData.title = '請先完善個人資料'
            popupData.message = newValue.message
            popupData.isColorClose = true
            openPopup()
            break
          case '1001':
            popupData.title = '尚未開通家樂福錢包'
            popupData.message = newValue.message
            popupData.isWallet = true
            popupData.isClose = true
            openPopup()
            break
          case '1002':
            popupData.title = '您已登記過囉！'
            popupData.message = newValue.message
            popupData.isColorClose = true
            openPopup()
            break
          case '2000':
            popupData.title = '活動已結束'
            popupData.message = newValue.message
            popupData.isColorClose = true
            openPopup()
            break
          default:
            popupData.type = 'fail'
            popupData.message = newValue.message
            openPopup()
            timer()
            break
        }
      }
    )
    return {
      result,
      isPopupOpen,
      handler,
      openPopup,
      closePopup,
      popupData,
      handleLogin,
      handleWallet
    }
  }
})
